import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Menu from "./components/Menu";
import Main from "./components/Main";
import Formacion from "./components/Formacion";
import Experiencia from "./components/Experiencia";
import ConocimientosBD from "./components/ConocimientosBD";
import ConocimientosLenguaje from "./components/ConocimientosLenguaje";
import OtrosConocimientos from "./components/OtrosConocimientos";

import DynamicScrollToTop from "./routes/DynamicScrollToTop";

function App() {
  return (
    <Router>
      <DynamicScrollToTop />

      {/* MENÚ GLOBAL (sale en todas las páginas) */}
      <Menu />

      <Switch>
        <Route exact path="/" component={Main} />
        <Route exact path="/formacion" component={Formacion} />
        <Route exact path="/experiencia" component={Experiencia} />
        <Route exact path="/conocimientosBD" component={ConocimientosBD} />
        <Route exact path="/conocimientosLenguaje" component={ConocimientosLenguaje} />
        <Route exact path="/otrosConocimientos" component={OtrosConocimientos} />
      </Switch>
    </Router>
  );
}

export default App;
